import { useEffect, useRef } from 'react';
/** Buy-frame ready only acknowledges setup, not initiation or payment completion. */
export function useCardResultDeadline(enabled, attemptId, onExpired) {
  const expire = useRef(onExpired);
  expire.current = onExpired;
  useEffect(() => {
    if (!enabled || !attemptId) return;
    const timer = setTimeout(() => expire.current(), 20000);
    return () => clearTimeout(timer);
  }, [enabled, attemptId]);
}